import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import '../assets/css/libs.css'
import '../assets/css/style.css'
import { useDescription } from '../hook/useDescription'
import { useHeadTitle } from '../hook/useHeadTitle'
import { useSendEmbedSizeInfo } from '../hook/useSendEmbedHeight'
import { AppState } from '../store'
import { reset } from '../store/modules/calcReversal'
import { FinancialCalcReversalChart } from './FinancialCalcReversalChart'
import { FinancialCalcReversalForm } from './FinancialCalcReversalForm'
import { FinancialCalcReversalGuideModal } from './FinancialCalcReversalGuideModal'
import { Loading } from './Loading'

export interface FormInput {
  initial: number | string
  startAge: number | string
  interest: number | string
  isMonthlyWithdrawal: string // radio使う都合でstring
  disSavingRate: number | string
  addition: number | string
}

export const defaultValues = {
  initial: 2000,
  startAge: 60,
  interest: 3,
  isMonthlyWithdrawal: false,
  disSavingRate: '',
  addition: '',
}

export const constraintValues = {
  initial: {
    upper: 99999,
    lower: 1,
    decimalPoint: 0,
  },
  startAge: {
    upper: 99,
    lower: 20,
    decimalPoint: 0,
  },
  interest: {
    upper: 30.0,
    lower: 0,
    decimalPoint: 1,
  },
  disSavingRate: {
    upper: 15.0,
    lower: 0,
    decimalPoint: 1,
  },
  addition: {
    upper: 999.9,
    lower: 0,
    decimalPoint: 1,
  },
}

export const IframeFinancialCalcReversal: React.FC = () => {
  const dispatch = useDispatch()
  const { fetchState } = useSelector((state: AppState) => state.financialCalcReversal)
  const [isShowGuide, setShowGuide] = useState(false)

  useHeadTitle('今こそ資産運用を考えよう', '取り崩しシミュレーション')
  useDescription(
    'シミュレーションを通じてご自身の資産運用を考えてみませんか。野村アセットマネジメントが資産運用に取り組む皆さまをサポートします。'
  )
  useEffect(() => {
    dispatch(reset())
    return () => {
      dispatch(reset())
    }
  }, [dispatch])

  useSendEmbedSizeInfo()

  const [isMonthlyWithdrawal, setIsMonthlyWithdrawal] = useState<boolean>(false)
  const [disSavingRate, setDisSavingRate] = useState<number | string | null>(null)
  const [addition, setAddition] = useState<number | string | null>(null)

  const isPending = fetchState === 'pending'
  return (
    <React.Fragment>
      <main className="include torikuzushi">
        <section>
          <div className="c-title-wrap">
            <h2 className="c-title--primary">取り崩しシミュレーション</h2>
            <p className="u-text--right">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="#" className="c-title__link-info" onClick={() => setShowGuide(true)}>
                使い方ガイド
              </a>
            </p>
          </div>
          <div id="app-root" role="application">
            <div className="u-bg--white reversal">
              <div className="l-container">
                <div className="p-simulation">
                  <div className="p-simulation__container">
                    <FinancialCalcReversalForm
                      isPending={isPending}
                      isResponsive={true}
                      setIsMonthlyWithdrawal={setIsMonthlyWithdrawal}
                      setDisSavingRate={setDisSavingRate}
                      setAddition={setAddition}
                    />
                    <Loading apiStatus={fetchState} />
                  </div>
                  <FinancialCalcReversalChart
                    isResponsive={true}
                    isMonthlyWithdrawal={isMonthlyWithdrawal}
                    disSavingRate={disSavingRate}
                    addition={addition}
                  />
                  <div className="u-mt20px">
                    <p className="c-note">
                      将来の運用成果を示唆あるいは保証するものではありません。内容の正確性、完全性、適合性等を保証するものではありません。
                      当該情報の利用による投資等の損益はすべてお客さまに帰属し、野村アセットマネジメント株式会社は一切責任を負いません。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <FinancialCalcReversalGuideModal isShow={isShowGuide} setShow={setShowGuide} />
        </section>
        <div id="modal-root"></div>
      </main>
    </React.Fragment>
  )
}
